import { AfterContentInit, Component, EventEmitter, Input, Output, OnDestroy, OnChanges, OnInit } from '@angular/core';
import { Brand, INDRA_getFeatureForTAC, INDRA_getCheckedBaggageDetails, getBrandFeatures } from './brand.indra';
import { BrandComponent } from './brand.component';
import { DomSanitizer } from '@angular/platform-browser';

import * as fromStore from '../../../../store';

import { Observable, combineLatest } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { Flight } from '@ibe/models';
import * as _ from 'lodash';

import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRAFeature } from '@ibe.models/ancillary.indra.model.lib';
import { getCurrencySymbol } from '@angular/common';
import { BookingStep } from '@ibe/models/ui';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';


import {
	AIRLINE_TAP_CODE,
	SSR_CODES_IGNORE_LIST,
	TRANSLATION_ANCILLARY_GROUP,
	TRANSLATION_MODULES_BOOKING_FLIGHTS_PAGE,
	DEFAULT_LANGUAGE,
	BASIC_ANCILLARY_CODES_FLIGHT_CHANGES,
	BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE,
	BASIC_ANCILLARY_CODES_MILES,
	SESSION_VAR_KEY_CURRENCY,
	FLIGHT_HAUL_TYPE_LONG,
	AIRPLANE_EQUIPMENT_CODE_332,
	AIRPLANE_EQUIPMENT_CODE_32Q,
	AIRPLANE_EQUIPMENT_CODE_339,
	AIRPLANE_EQUIPMENT_CODE_32N,
	COUNTRY_CODE_VENEZUELA,
	COUNTRY_CODE_BRAZIL,
	BRAND_CODE_EXECUTIVE,
	BRAND_CODE_TOP_EXECUTIVE,
	BRAND_CODE_PLUS,
	BRAND_CODE_AWARD_EXECUTIVE,
	BASIC_ANCILLARY_CODES_MEALS,
	BASIC_ANCILLARY_CODES_SNACK,
	BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS,
	SSR_CODE_REFUNDS,
	SSR_CODE_CHANGES,
} from '@ibe.config';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';

@Component({
	selector: 'app-brand',
	templateUrl: './brand.indra.component.html',
	styleUrls: ['./brand.component.scss'],
	host: {
		class: 'brand'
	}
})
export class INDRABrandComponent extends BrandComponent
	implements AfterContentInit, OnDestroy, OnChanges, OnInit {
	@Input()
	brand: Brand;

	@Input()
	isSelected = false;

	@Input()
	index;

	@Input()
	economyxtra: boolean = false;

	@Input()
	ancillariesList?;

	@Input()
	includedAncillaries?;

	@Input()
	milesGoDiscount;

	@Input()
	otherBrandHasEconomyExtra: boolean = false;

	@Input()
	milesTobeEarned?;
	
	@Input()
	selectedBrand: string;

	@Input()
	isLoggedIn;

	@Output()
	selected = new EventEmitter<any>();

	@Output()
	selectConfirm = new EventEmitter<any>();

	@Output()
	clickFeature = new EventEmitter<any>();

	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean;
	discountMiles$: Observable<number> = this.store.select(fromStore.getMilesBarDiscount);
	discountMiles: number = 0;
	private current_step$: Observable<number> = this.store.select(fromStore.getSelectedBookingCurrentStep);
	private booking_type$: Observable<string> = this.store.select(fromStore.getSelectedBookingType);
	booking_type: string;
	brandState: string;
	current_step: number;
	private timeToThink$: Observable<boolean> = this.store.select(fromStore.getBookingStepsTTT);
	price_difference = '';
	flightFilter$: Observable<any> = this.store.select(fromStore.getFlightsFilterState);
	flightFilter: any;
	isStarAlliance: boolean = false;
	flight$: Observable<Flight> = this.store.select(fromStore.getSelectedFlightFromFlightResults);
	flight;

	routeType$: Observable<any> = this.store.select(fromStore.getMiniIBERouteType);
	tripType;

	hasChanges$: Observable<any> = combineLatest(
		[this.flightFilter$,
		this.flight$]
	);

	features = [];
	isAlive = true;

	// Show features collapsed (on mobile)
	// Collapsed by default
	isCollapsed;
	timeToThink: boolean;
	displayBrandImage: boolean = false;
	haulType;
	significantFlightSegmentEquipment;

	bookingSteps$: Observable<BookingStep[]> = this.store.select(
		fromStore.getSelectedBookingSteps
	);
	bookingSteps: Array<BookingStep>;

	currency: any;

	isFirstClass: boolean = false;
	firstClassFlightSegmentNumbers;
	starAllianceFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterStarAllianceFlights);
	starAllianceFlights: boolean;

	BAG_ANCILLARY_CODE = BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE;

	transFlightData: any;

	constructor(
		private store: Store<fromStore.State>,
		private sanitizer: DomSanitizer,
		private sidebarService: SidebarService,
		private ibeAdminService: INDRAIbeAdminService,
		private ancillariesService: INDRAAncillariesService,
		private currencyService: INDRACurrencyService,
		private bookingSearchService: INDRABookingSearchService,
		private storageService: INDRAStorageService
	) {
		super();
		this.isCollapsed = true;

		this.bookAwardFlights$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.bookAwardFlights = value;
			});

		this.discountMiles$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(discountMiles => this.discountMiles = discountMiles);

		this.current_step$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.current_step = value;
			});

		this.booking_type$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.booking_type = value;
			});

		this.timeToThink$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.timeToThink = value;
			});

		this.flight$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.flight = value;
				if (value) {
					if (this.INDRA_isTAP()) {
						this.economyxtra = false;
					}

				}
			});

		this.bookingSteps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.bookingSteps = value;
				}
			});

		this.hasChanges$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(([flightFilter, flight]) => {
				if (flightFilter) {
					this.flightFilter = flightFilter;
					this.isStarAlliance = flightFilter.starAlliance;
				}
				this.INDRA_displayBrandImage();
			});

		this.starAllianceFlights$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(values => {
				this.starAllianceFlights = values;
			});

		this.routeType$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(routeType => {
				this.tripType = routeType;
			});
	}

	ngOnInit() {
		this.ibeAdminService.loadTranslations('tap', TRANSLATION_MODULES_BOOKING_FLIGHTS_PAGE,
			(sessionStorage.getItem('language') ? sessionStorage.getItem('language') : DEFAULT_LANGUAGE));

		if (this.starAllianceFlights) {
			this.isFirstClass = this.INDRA_isFirstClass(this.brand);
		}

		this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;

		this.transFlightData = {
			...this.flight
		}
	}

	ngAfterContentInit() {
		this.brandState = this.brand.state;

		let NO_PREMIUM_FEATURES = false;

		if (this.brand.features == 'all') NO_PREMIUM_FEATURES = true;
		if (this.bookAwardFlights) NO_PREMIUM_FEATURES = this.bookAwardFlights;


		//this.price_difference = this.getPrice_difference();
		this.features = getBrandFeatures(this.brand.name, { NO_PREMIUM_FEATURES }).filter(
			feature => feature.type == 'added'
		);


		// if (this.isSelected) {
		// 	this.selected.emit(this.isSelected);
		// }
	}

	ngOnChanges() {
		if (this.ancillariesList && this.ancillariesList.length) {
			// Rebrand: show only 'added'/what's included ancillaries 
			const allFeatures = this.ancillariesList.map(ancillary => this.INDRA_composeFeature(ancillary));
			const features = allFeatures.filter(anc => anc.type == 'added');

			// If both meals and snack exist, just remove snack item
			const snackIndex = features.findIndex(f => f.code === BASIC_ANCILLARY_CODES_SNACK);
			const mealIndex = features.findIndex(f => f.code === BASIC_ANCILLARY_CODES_MEALS);
			if(snackIndex > -1 && mealIndex > -1) {
				features.splice(snackIndex, 1)
			}

			// If free changes are included, add them
			const changesIndex = features.findIndex(f => f.code === BASIC_ANCILLARY_CODES_FLIGHT_CHANGES);
			if (changesIndex > -1 && this.brand.changes === "FREE") {
				features[changesIndex].includedAncillaries.push(SSR_CODE_CHANGES);
			}

			// If refunds are included, add them
			const refundsIndex = features.findIndex(f => f.code === BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS);
			if (refundsIndex > -1 && this.brand.refunds !== "NONE") {
				features[refundsIndex].includedAncillaries.push(SSR_CODE_REFUNDS);
			}

			this.features = features;
		}
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	/**
	 * Wrapper for brand name
	 */
	get INDRA_brandName() {
		return this.brand.name;
	}

	/**
	 * Wrapper for brand recommended flag
	 */
	get INDRA_isRecommended(): boolean {
		return this.brand.recommended;
	}

	/**
	 * @returns true if feature is included in this brand free of charge
	 */
	INDRA_featureIsAdded(feature): boolean {
		return feature.type === 'added';
	}
	/**
	 * @returns true if feature is available as an extra
	 */
	INDRA_featureIsAvailable(feature): boolean {
		return feature.type === 'available';
	}

	/**
	 * Wrapper for @feature type
	 * @param feature
	 */
	INDRA_featureType(feature) {
		if (feature.extra) {
			const ngClass = { extra: true };
			ngClass[feature.type] = true;

			return ngClass;
		}
		return feature.type;
	}

	/**
	 * Wrapper for @feature label
	 * @param feature
	 */
	INDRA_featureLabel(feature): string {
		const label = feature.label.replace(/\s/g, '').toLowerCase();

		if (label.includes('-')) {
			return label.replace('-', '');
		} else {
			return label;
		}
	}

	/**
	 * Wrapper for @feature icon
	 * @param feature
	 */
	INDRA_featureIcon(feature): string {
		return feature.icon;
	}

	/**
	 * Wrapper for @feature starting price
	 * @param feature
	 */
	INDRA_featurePrice(feature): number {
		return feature.price;
	}

	/**
	 * Handles Brand selection
	 */
	INDRA_handleClickSelect() {
		this.selected.emit(true);
	}

	/**
	 * Handles Brand selection on mobile
	 */
	INDRA_handleClickSelectConfirm() {
		this.selectConfirm.emit(true);
	}

	/**
	 * Handles Brand selection on mobile
	 */
	INDRA_handleClickToggleExpandFeatures() {
		this.isCollapsed = !this.isCollapsed;
	}

	/**
	 * Open Economy Xtra modal
	 */
	INDRA_handleClickOpenEconomyxtraDetails() {
		this.sidebarService.openSidebar(['economyxtra-details']);
	}

	/**
	 * Returns features list classes
	 */
	INDRA_featureListClasses() {
		return { 'is-collapsed': this.isCollapsed };
	}

	/**
	 * Calculates the price difference to the lowest price on the screen
	 */
	getPrice_difference() {
		let lowest_price;
		const currencySymbol = this.currencyService.INDRA_getCurrencySymbol().unit;
		const lowest_brand = document.getElementsByClassName(
			'brand__price-value'
		)[0];
		lowest_price = +lowest_brand.textContent.split(
			currencySymbol
		)[0];
		if (lowest_price === this.brand.price || lowest_price === 0) {
			return 'Lowest price';
		}
		return (
			'+' + (this.brand.price - lowest_price) + currencySymbol
		);
	}

	/**
	 * Wrapper for price difference to the lowest price on the dom
	 */
	get INDRA_price_difference() {
		return this.price_difference;
	}

	/**
	 * @returns human-readable brand price
	 */
	get INDRA_printPrice() {

		let discountMiles = 0;
		if (this.milesGoDiscount) {
			if (this.booking_type === 'R') {
				discountMiles = this.discountMiles / 2;
			} else {
				discountMiles = this.discountMiles;
			}
		}
		if (this.bookAwardFlights)
			return this.brand.bookAwardValue + ' M';
		
		if (this.isLoggedIn) {
			if (this.bookAwardFlights) {
				return this.brand.bookAwardValue + ' M';
			}
				
			return parseFloat(this.brand.price - discountMiles + '').toFixed(2) + this.currency;
		} else {
			if (this.bookAwardFlights) {
				return this.brand.bookAwardValue + ' M';
			}
				
			return parseFloat(this.brand.price + '').toFixed(2) + this.currency;
		}
		
	}

	INDRA_handleClickFeature(feature) {
		this.INDRA_getSelectedTAC();

		this.clickFeature.emit(feature);
	}


	INDRA_featureExtra(feature) {
		return feature.extra ? feature.extra : false;
	}

	INDRA_getBrandImage() {
		let imageFile;
		switch (this.brand.name) {
			case 'discount':
			case 'basic':
			case 'miles&go-economy':
				if (this.haulType === FLIGHT_HAUL_TYPE_LONG) imageFile = 'lh-green.jpg';
				else imageFile = 'mh-green.jpg';
				break;

			case 'classic':
			case 'plus':
				if (this.haulType === FLIGHT_HAUL_TYPE_LONG) imageFile = 'lh-red.jpg';
				else {
					if (this.brand['economy-extra-elegible'] && this.brand['red-and-green-elegible']) {
						imageFile = 'red.gif'
					}
					else {
						imageFile = 'mh-red.jpg';
					}
				}
				break;

			case 'miles&go-extra':
				imageFile = 'red.gif';
				break;

			case 'executive':
			case 'top-executive':
				if (this.haulType === FLIGHT_HAUL_TYPE_LONG) {
					if (this.significantFlightSegmentEquipment === AIRPLANE_EQUIPMENT_CODE_332) {
						imageFile = 'exe-330-200.jpg';
					} else if (this.significantFlightSegmentEquipment === AIRPLANE_EQUIPMENT_CODE_32Q) {
						imageFile = 'exe-321LR.png';
					} else if (this.significantFlightSegmentEquipment === AIRPLANE_EQUIPMENT_CODE_339) {
						imageFile = 'exe-330NEO.jpg';
					} else if (this.significantFlightSegmentEquipment === AIRPLANE_EQUIPMENT_CODE_32N) {
						imageFile = 'exe-A319 A320 A321.jpg'
					}
				}
				else imageFile = 'exe-A319 A320 A321.jpg';
				break;

			case 'miles&go-executive':
				imageFile = 'miles-go-executive.jpg';
				break;

			default:
				// TODO - Default image
				imageFile = '';
				return false;
		}
		const url = 'assets/images/brands/' + imageFile;
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}

	/**
	 *	Check if brand images should be displayed. Images can only be shown if the most significant segment 
	 *  is operated by TAP and is an airbus
	 */
	INDRA_displayBrandImage() {
		if (this.flight && !this.isStarAlliance) {
			const significantFlightSegment = this.bookingSearchService.INDRA_getTAPMostSignificantFlightSegment(this.flight);
			this.haulType = significantFlightSegment ? significantFlightSegment.haul : null;
			if (significantFlightSegment &&
				this.bookingSearchService.INDRA_isAirbusModel(significantFlightSegment.equipment)) {
				this.significantFlightSegmentEquipment = significantFlightSegment.equipment;
				this.displayBrandImage = true;
			}
		}
	}

	INDRAisBrandAvailable(): boolean {
		return this.brand.state === 'available' ? true : false;
	}

	INDRA_showEconomyExtra() {
		if (this.flight.listSegment.length >= 1 && this.INDRA_isTAP() && this.economyxtra && this.brand['economy-extra-elegible']) {
			return true;
		}
		return false;
	}

	INDRA_isCodeShareFlight() {
		return this.bookingSearchService.INDRA_isCodeShareFlight(this.flight);
	}

	INDRA_isTAP(): boolean {
		for (let x = 0; x < this.flight.listSegment.length; x++) {
			if (this.flight.listSegment[x].carrier == AIRLINE_TAP_CODE) {
				return true;
			}
		}
		return false;
	}

	INDRA_composeFeature(ancillary) {
		let labelPrefix = '';
		if (ancillary.code === BASIC_ANCILLARY_CODES_FLIGHT_CHANGES && ancillary.free) {
			labelPrefix = 'Free';
		}

		const isIndirectFlight = this.flight ? this.flight.listSegment.length > 1 : false;

		const featureTemplate = INDRA_getFeatureForTAC(ancillary.code, this.brand.name, this.brand['red-and-green-elegible'], this.haulType, isIndirectFlight);
		const feature: INDRAFeature = {
			id: featureTemplate.id,
			code: ancillary.code,
			label: labelPrefix ? labelPrefix + ' ' + featureTemplate.label : featureTemplate.label,
			labelTranslationKey: labelPrefix ? featureTemplate.labelTranslationKey + labelPrefix : featureTemplate.labelTranslationKey,
			type: (ancillary.free ? 'added' : (ancillary.available ? 'available' : 'unavailable')),
			extra: this.brand['economy-extra-elegible'],
			icon: featureTemplate.icon,
			price: ancillary.amount,
			currency: ancillary.currency,
			description: featureTemplate.description,
			details: featureTemplate.details,
			flight_details: featureTemplate.flight_details,
			includedAncillaries: this.ancillariesService.getAncillaryIncludedPerBasicAncillary(ancillary.code, this.includedAncillaries),
			otherRelatedBrandIsExtra: this.otherBrandHasEconomyExtra,
			toolTip: this.INDRA_translateTooltip(featureTemplate, this.brand.name)
		};

		//Update availability display of seat details
		switch (this.brand.name) {
			case BRAND_CODE_EXECUTIVE:
			case BRAND_CODE_TOP_EXECUTIVE:
			case BRAND_CODE_AWARD_EXECUTIVE:
				if (feature.id == 'seats') {
					feature.label = 'freeseatreservationv2';
					feature.labelTranslationKey = this.INDRA_getTranslationValue('availability.flightsPage.text.freeseatreservationv2');
					feature.toolTip = this.INDRA_getTranslationValue('whatsIncludedSidebars.text.inAnyArea');
				}
				break;
			case BRAND_CODE_PLUS:
				if (feature.id == 'seats') {
					if (feature.extra) {
						feature.label = 'Comfort seat reservation';
						feature.toolTip = this.INDRA_getTranslationValue('bookingDetails.text.extraLegroomAndReclining');
						feature.icon = 'plane_related--tap_executive';
					}
				}
				break;
			default:
				break;
		}

		// get amountlabel if applicable (checked bag or miles)
		feature.amountLabel = this.INDRA_getAmountLabel(feature);
		return feature;
	}

	INDRA_translateTooltip(feature, brand) {
		let translatedText;
		if (feature['toolTip']) {
			if (feature['toolTip'].includes(' ')) {
				const textsArr = feature['toolTip'].split(' ');
				textsArr.forEach((text, i) => {
					// if (i > 0) {
					// 	if (feature.id == 'bags' && this.flight.countryCodes.some(country => country == COUNTRY_CODE_BRAZIL
					// 		|| country == COUNTRY_CODE_VENEZUELA)) {
					// 		if (brand != BRAND_CODE_EXECUTIVE && brand != BRAND_CODE_TOP_EXECUTIVE) {
					// 			// 10kg if from/to BR/VE
					// 			translatedText += this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsHandLuggage.text.baggageAllowance10kg');
					// 		} else {
					// 			translatedText += this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsHandLuggage.text.baggageAllowance8kg');
					// 		}
					// 	} else {
					// 		translatedText += feature.id === 'checked-baggage' && (brand === 'top-executive' || brand === 'executive') ?
					// 			this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsLuggage.texts.maxWeightSpecsBusiness') : this.INDRA_getTranslationValue(text);
					// 	}
					// } else {
					// 	translatedText = this.INDRA_getTranslationValue(text) + ' ';
					// }

					if (i > 0) {
						if (feature.id == 'bags') {
							translatedText += this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsHandLuggage.text.baggageAllowance10kg');
						} else {
							translatedText += feature.id === 'checked-baggage' && (brand === 'top-executive' || brand === 'executive') ?
								this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsLuggage.texts.maxWeightSpecsBusiness') : this.INDRA_getTranslationValue(text);
						}
					} else {
						translatedText = this.INDRA_getTranslationValue(text) + ' ';
					}

					if (feature.id == 'bags' && i == 0) {
						translatedText += '+ ';
					}
				});
			} else {
				translatedText = this.INDRA_getTranslationValue(feature['toolTip']);;

				if (feature.id == 'seats') {
					switch (brand) {
						case 'plus':
							translatedText = this.INDRA_getTranslationValue('ancillaries.detailed.PSEAT');
							break;
						case 'top-executive':
						case 'executive':
							translatedText = this.INDRA_getTranslationValue('whatsIncludedSidebars.text.inAnyArea');
							break;
						default:
							break;
					}
				}
			}
		}

		return translatedText
	}

	INDRA_getAmountLabel(feature) {
		let amount;
		if (feature && feature.code === BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE &&
			feature.includedAncillaries && feature.includedAncillaries.length > 0) {
			// checked baggage bag count
			// assumption is only 1 baggage ancillary will be included during initial booking
			const holdBaggageAncillaryCode = feature.includedAncillaries[0];
			const ancillaryBaggageDetails = INDRA_getCheckedBaggageDetails(holdBaggageAncillaryCode);
			if (ancillaryBaggageDetails) {
				amount = ancillaryBaggageDetails.count;
			}
		} else if (feature && feature.code === BASIC_ANCILLARY_CODES_MILES && this.milesTobeEarned !== null && this.milesTobeEarned > 0) {
			// miles to be earned by taking the flight
			amount = this.milesTobeEarned;
		}
		return amount;
	}

	INDRA_getTranslation(key: string): Observable<string> {
		return this.ibeAdminService.getTranslationValueAsync(key);
	}

	INDRA_getCurrency(feature: any) {
		return feature.currency != null ? this.currency : '';
	}

	INDRA_getTax() {
		const cloneBrand = _.cloneDeep(this.brand);
		return ` + ${this.currencyService.INDRA_formatCash(cloneBrand.tax)} ${this.currency}`;
	}

	INDRA_showWarning(option: number): boolean {
		switch (option) {
			case 0:
				return this.isFirstClass;
			default:
				break;
		}
		return false;
	}

	INDRA_isFirstClass(brand) {
		let isFirstClass = false;
		const firstClassFlightSegmentNumbers = [];
		if (brand) {
			const bound = (this.current_step === 0) ? 'outbound' : 'inbound';
			const firstClassDislaimerIndex = [];
			if (brand.offer[bound]['firstClassDisclaimer']) {
				for (let i = 0; i < brand.offer[bound].firstClassDisclaimer.length; i++) {
					if (brand.offer[bound].firstClassDisclaimer[i]) {
						firstClassDislaimerIndex.push(i);
					}
				}
			}
			if (firstClassDislaimerIndex.length > 0) {
				isFirstClass = true;
				firstClassDislaimerIndex.forEach(idx => {
					const flightSegment = this.flight.listSegment[idx];
					const flightNumber = flightSegment.carrier + flightSegment.flightNumber;
					if (!firstClassFlightSegmentNumbers.includes(flightNumber)) {
						firstClassFlightSegmentNumbers.push(flightNumber);
					}
				});
			}
		}

		if (firstClassFlightSegmentNumbers.length > 0) {
			this.firstClassFlightSegmentNumbers =
				firstClassFlightSegmentNumbers.reduce((acc, curr) => (acc !== '' ? acc + ', ' + curr : curr));
		}

		return isFirstClass;
	}

	INDRA_getTranslationValue(key: string) {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_capitalizeFirstLetter(value: string): string {
		if (value && value.length > 0) {
			let transText: string = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
			return transText;
		} else {
			return;
		}
	}

	INDRA_handleTicketConditionsClick(event) {
		event.stopPropagation();

		this.INDRA_getSelectedTAC();

		this.sidebarService.openSidebar([
			'ticket-conditions',
			{
				flight: this.flight.idFlight,
				brand: this.brand.name
			}
		]);
	}

	INDRA_getSelectedTAC() {
		this.transFlightData = {
			...this.flight,
			cabin: this.brand['cabinType'].length > 0 ? this.brand['cabinType'][0] : null,
			mixedCabins: this.brand['cabinType'].length > 1 ? this.INDRA_checkMixedCabins(this.brand['cabinType']) : false,
			brandCode: this.brand.name,
			fareFamily: true
		}

		this.storageService.set('availabilityFlightData', this.transFlightData)
		
		let selectedInfoTAC: any = {
			"fare-information": {
				[this.flight.idFlight]: {
					'ancillaries': this.brand['basic-ancillaries'],
					'includedAncillaries': this.brand['ancillaries'],
					'changes': this.brand['changes'],
					'changes-fee': this.brand['changes-fee'],
					'changes-description': this.brand['changes-description'],
					'refunds': this.brand['refunds'],
					'refounds-fee': this.brand['refounds-fee'],
					'refunds-description': this.brand['refunds-description'],
					'milesPercentage': this.brand['milesPercentage'],
					'miles': this.brand['miles'],
					'actualMiles': this.brand['actualMiles'],
					'economy-extra-elegible': this.brand['economy-extra-elegible'],
					'extra-ancillaries': this.brand['extra-ancillaries'],
					'red-and-green-elegible': this.brand['red-and-green-elegible'],
					'no-show': this.brand['no-show'],
					'no-show-fee': this.brand['no-show-fee'],
					'mealImage': this.brand['mealImage'],
					'mealImageBySegment': this.brand['mealImageBySegment'],
					
				}
			},
			airport: this.storageService.get('airportTranslationData')
		}
		this.storageService.set('selectedInfoTAC', selectedInfoTAC)
	}

	INDRA_checkMixedCabins(cabins) {
		return !cabins.every(v => v === cabins[0]);
	}

}
